export default {
  formData: [],
  dummyData: [],

  generateDocumentsFormData: {},
}